export default "__VITE_ASSET__oMAvf2n___"